import { ApiService } from "./api.service";
export default class TasklistService extends ApiService {
  namespace = "tasklist";
  icon = "TaskList";
  name = "TaskList";
  favicon = "ClipboardWithTasks";
  Width = 690;
  domain = -13;
  action = "action";
  constructor() {
    super("tasklists");
  }
}
